import React from 'react'
import ReaderMain from 'components/Reader'

function ReaderPage() {
  return <ReaderMain />
}

export default ReaderPage
